import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const Logs = ({ server_id }) => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [links, setLinks] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const { t } = useTranslation();

  const fetchLogs = async (
    url = `${api_url}/ldap/servers/${server_id}/logs`
  ) => {
    try {
      const token = localStorage.getItem("userToken");
      if (!token) return;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      console.log("API Response:", result);

      if (result.status === "success" && result.data?.data) {
        setData(result.data.data);
        setAllData(result.data.data);
        setLinks(result.data.links || []);
      } else {
        toast.error(t("unexpectedDataFormat"));
      }
    } catch (err) {
      toast.error(t("fetchLogsError"));
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [server_id]);

  useEffect(() => {
    if (searchVal.trim()) {
      const filtered = allData.filter(
        (item) =>
          item.level?.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.message?.toLowerCase().includes(searchVal.toLowerCase()) ||
          JSON.stringify(item.context)
            ?.toLowerCase()
            .includes(searchVal.toLowerCase())
      );
      setData(filtered);
    } else {
      setData(allData);
    }
  }, [searchVal, allData]);

  const columns = [
    {
      accessorKey: "event",
      header: () => (
        <div className="d-flex align-items-center gap-2">{t("Event")}</div>
      ),
      colName: t("Event"),
    },
    {
      accessorKey: "level",
      header: () => (
        <div className="d-flex align-items-center gap-2">{t("Level")}</div>
      ),
      colName: t("Level"),
    },
    {
      accessorKey: "message",
      header: () => (
        <div className="d-flex align-items-center gap-2">{t("Message")}</div>
      ),
      colName: t("Message"),
    },
    {
      accessorKey: "context.url",
      header: () => (
        <div className="d-flex align-items-center gap-2">{t("Context")}</div>
      ),
      colName: t("Context"),
    },
  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4 mb-4">
      <div className="primaryBlueBox p-5 mb-4">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("Logs")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchlogs")}
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light px-3 py-3 userTableWrapper resTable">
        {window.innerWidth < 768 ? (
          table.getRowModel().rows.map((row) => (
            <div key={row.id} className="stacked-row">
              {row.getVisibleCells().map((cell) => (
                <div key={cell.id} className="stacked-cell">
                  {cell.column.columnDef.colName && (
                    <strong>{cell.column.columnDef.colName}: </strong>
                  )}
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              ))}
            </div>
          ))
        ) : (
          <table className="table table-bordered table-hover">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th key={header.id}>
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? "active" : ""} ${
                link.url === null ? "disabled" : ""
              }`}
              onClick={link.url ? () => fetchLogs(link.url) : undefined}
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Logs;
